import React, { Component } from 'react';
//import {Button} from 'primereact/components/button/Button';

export class AiAppointment extends Component {
  
   

    render() {
        const id_zales='https://signetgem.secure.force.com/SelfScheduling/SUMO_services?brand=Zales'
        const id_zales_outlet='https://signetgem.secure.force.com/SelfScheduling/SUMO_services?brand=Zales_Outlet'
        const id_kay='https://signetgem.secure.force.com/SelfScheduling/SUMO_services?brand=Kay'
        const id_kayoutlet='https://signetgem.secure.force.com/SelfScheduling/SUMO_services?brand=Kay_Outlet'
        const id_pagoda='https://www.pagoda.com/virtual-appointments'
        const id_jared='https://signetgem.secure.force.com/SelfScheduling/SUMO_services?brand=Jared'
        const id_sterlingjewelers=''
        var id_cur=''
        //if ()
        switch (window.currentSite) {
            case "zalesoutlet":
                id_cur=id_zales_outlet;
                break;
            case "zales":
                    id_cur=id_zales;
                    break;
            case "peoplesjewellers":
                id_cur='';
                break;
            case "pagoda":
                id_cur=id_pagoda;
                break;
            case "sterlingjewelers":
                id_cur=id_sterlingjewelers;
                break;
            case "kay":
                id_cur=id_kay;
                break;
            case "kayoutlet":
                id_cur=id_kayoutlet;
                break;
            case "jared":
                id_cur=id_jared;
                break;
            default:
                id_cur=''
                break;
        }
        //console.log('cur',window.currentSite,id_cur)
      
   
        if (id_cur==='')
            return (<div/>)
        else
        return (
        <div className='ai-appointment-review-div'>
        <div className='ai-appointment-review-0'>
        </div>       
       
             
        
        </div>)
        

    }
}
export default AiAppointment;



// WEBPACK FOOTER //
// ./src/layout/AiAppointment.js